export const boxStyled = {
  border: '1px solid $medium-light-2',
  margin: '56px auto 0',
  padding: '20px',
  borderRadius: 8,
}

export const flexStyled = { height: '42vh' }

export const h2Styled = { fontSize: '24px', textAlign: 'center' }
